<template>
  <div class="ts-space-y-2">
    <div 
      class="hover:ts-shadow-md ts-border ts-cursor-pointer ts-border-gray-300 ts-mb-4 ts-rounded-md ts-overflow-hidden ts-mx-auto ts-w-1/2"
    >
      <div class="ts-pt-1/2 ts-relative">
        <label for="logo-image" class="ts-w-full ts-h-full ts-cursor-pointer ts-absolute ts-top-0">
          <img id="logo" class="ts-w-full ts-h-full ts-object-contain" :src="logo_file_src" alt />
        </label>
      </div>
      <input
        type="file"
        id="logo-image"
        ref="logoimage"
        style="display:none"
        @change="onFileChange"
      />
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="ts-text-xs required">{{
          $t('bankProfile.bankName')
        }}</label>
        <input
          v-model="model.bank_name"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('bank_name') }"
        />
        <div class="invalid-feedback ts-text-xs" v-if="errors.has('bank_name')">
          {{ errors.first('bank_name') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="required ts-text-xs">{{
          $t('bankProfile.accountNumber')
        }}</label>
        <div class="ts-border ts-border-blue-300 ts-rounded ts-p-2 ts-relative">
          <div
            class="overflow-auto"
            style="min-height: 300px; max-height: 400px"
          >
            <table>
              <thead>
                <tr class="ts-uppercase ts-bg-gray-200 ts-sticky ts-top-0">
                  <th
                    class="ts-p-1 ts-border-white ts-border"
                    style="width: 20%"
                  >
                    <label class="ts-m-0">{{ $t('bankProfile.prefix') }}</label>
                  </th>
                  <th class="ts-p-1 ts-border-white ts-border">
                    <label class="required ts-m-0">{{
                      $t('bankProfile.accountNumber')
                    }}</label>
                  </th>
                  <th class="ts-p-1 ts-border-white ts-border">
                    <label class="required ts-m-0">{{
                      $t('bankProfile.accountName')
                    }}</label>
                  </th>
                  <th
                    class="ts-p-1 ts-border-white ts-border ts-text-center"
                    style="width: 5%"
                  >
                    <a
                      href="#"
                      class="text-primary"
                      @click.prevent="addAccount"
                    >
                      <i class="fas fa-plus"></i>
                    </a>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(a, index) in model.account_number" :key="index">
                  <td class="ts-p-1 ts-border-white ts-border ts-align-top">
                    <input
                      v-model.trim="a.prefix"
                      type="text"
                      class="form-control"
                      :placeholder="$t('bankProfile.prefix')"
                      :class="{
                        'is-invalid': errors.has(
                          'account_number.' + index + '.prefix'
                        )
                      }"
                    />
                  </td>
                  <td class="ts-p-1 ts-border-white ts-border">
                    <input
                      v-model.trim="a.account_number"
                      type="text"
                      class="form-control"
                      :placeholder="$t('bankProfile.accountNumber')"
                      :class="{
                        'is-invalid': errors.has(
                          'account_number.' + index + '.account_number'
                        )
                      }"
                    />
                  </td>
                  <td class="ts-p-1 ts-border-white ts-border">
                    <input
                      v-model.trim="a.account_name"
                      type="text"
                      class="form-control"
                      :placeholder="$t('bankProfile.accountName')"
                      :class="{
                        'is-invalid': errors.has(
                          'account_number.' + index + '.account_name'
                        )
                      }"
                    />
                  </td>
                  <td class="ts-p-1 ts-border-white ts-border ts-text-center">
                    <a
                      href="#"
                      class="text-danger"
                      @click.prevent="remove(index)"
                    >
                      <i class="fa fa-trash"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="ts-text-xs">{{ $t('bankProfile.description') }}</label>
        <textarea
          rows="3"
          class="form-control"
          v-model.trim="model.description"
        ></textarea>
        <div
          class="invalid-feedback ts-text-xs"
          v-if="errors.has('description')"
        >
          {{ errors.first('description') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 ts-mt-3 text-right">
        <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
          {{ $t('cancel') }}
        </ts-button>
        <ts-button
          v-if="!isUpdate"
          color="primary"
          @click.prevent="onSave"
          :waiting="waiting"
          >{{ $t('save') }}</ts-button
        >
        <ts-button
          v-if="isUpdate"
          color="primary"
          @click.prevent="onUpdate"
          :waiting="waiting"
          >{{ $t('update') }}</ts-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
  name: 'bankProfileForm',
  data () {
    return {
      errors: new Errors(),
      waiting: false,
      waiting_new: false,
      logo_file: null,
      logo_file_src: require('@/assets/upload.png'),
      model: {
        bank_id: 0,
        bank_name: null,
        description: null,
        bank_logo: null,
        account_number: [
          {
            prefix: null,
            account_number: null,
            account_name: null
          }
        ]
      }
    }
  },
  created () {
    this.setEditData()
  },
  computed: {
    ...mapState('corporate/bankProfile', ['edit_data']),
    isUpdate () {
      return !_.isEmpty(this.edit_data)
    }
  },
  methods: {
    onFileChange() {
      const file = this.$refs.logoimage.files[0]
      let reader = new FileReader()
      reader.addEventListener(
        'load',
        function() {
          this.logo_file_src = reader.result
        }.bind(this),
        false
      )
      if (file) {
        if (/\.(jpe?g|png)$/i.test(file.name)) {
          reader.readAsDataURL(file)
          this.logo_file = file
        } else {
          this.logo_file_src = require('@/assets/upload.png')
          this.$toasted.error('invalid file type!')
          this.$refs.logo_file.value = ''
        }
      }
    },
    async uploadLogo() {
      if ((this.logo_file instanceof File) | Blob) {
        let formData = new FormData()
        formData.append('file', this.logo_file)
        let response = await this.$store.dispatch(
          'corporate/bankProfile/upload',
          formData
        )
        this.model.bank_logo = response
      }
      return ''
    },
    addAccount () {
      this.model.account_number.push({
        prefix: null,
        account_number: null,
        account_name: null
      })
    },
    remove (index) {
      this.model.account_number.splice(index, 1)
    },
    async onSave () {
      this.waiting = true
      await this.uploadLogo()
      this.$store
        .dispatch('corporate/bankProfile/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    async onUpdate () {
      this.waiting = true
      await this.uploadLogo()
      this.$store
        .dispatch('corporate/bankProfile/update', {
          id: this.model.bank_id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData () {
      if (!_.isEmpty(this.edit_data)) {
        this.model.bank_id = this.edit_data.bank_id
        this.model.bank_name = this.edit_data.bank_name
        this.model.description = this.edit_data.description
        this.model.bank_logo = this.edit_data.bank_logo
        if (this.edit_data.bank_logo) {
          this.logo_file_src = this.edit_data.bank_logo
        }
        this.model.account_number = this.edit_data.accounts.map(el => ({
          prefix: el.prefix,
          account_number: el.account_number,
          account_name: el.account_name
        }))
      }
    }
  }
}
</script>
